import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PasswordPolicyResponse } from "@core/models/api.response";
import { environment } from "@env/environment";
import { Observable, of, throwError } from "rxjs";
import { catchError, delay } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class PasswordPolicyService {
  constructor(private http: HttpClient) {}

  getPasswordPolicy(): Observable<PasswordPolicyResponse> {
    return this.http
      .get<PasswordPolicyResponse>(`${environment.apiUri}/auth/password/policy`)
      .pipe(
        catchError((error) => {
          return throwError(
            () =>
              new Error(
                error.error?.message ??
                  error.message ??
                  "An unknown error has occurred, please try again."
              )
          );
        })
      );
  }
}
